export const WaterTankFull = ({ width = '25', height = '24' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 25 24"
  >
    <path
      fill="#363BC4"
      d="M7.5 15.429v2.857c0 .225.043.448.127.656s.206.397.361.556.339.285.54.372c.203.086.42.13.639.13h6.666c.22 0 .436-.044.638-.13s.386-.213.54-.372c.156-.16.278-.348.362-.556s.127-.431.127-.656v-2.857zM7.5 9.144v5.714h10V9.144zM17.5 8.571V7.087c0-.32-.087-.633-.25-.905a1.7 1.7 0 0 0-.678-.632 9 9 0 0 0-2.128-.765V4h-3.888v.785a9 9 0 0 0-2.128.765c-.278.142-.513.36-.677.632a1.75 1.75 0 0 0-.251.905V8.57z"
    />
  </svg>
);
